import React, { useContext, useMemo } from "react";
import { cloudinaryUrl, logger } from "@bn-monorepo/js-packages";

import { SettingsContext } from "../../../settingsContext";
import styles from "./style.module.scss";
import { Box, BoxProps } from "@mui/material";

interface Props {
  imagePath: string;
  AltText: string;
  className?: string;
  styleOverride?: {
    width?: string;
    borderRadius?: string;
  };
  width?: number;
  height?: number;
  maxWidth?: number;
  noWrapper?: boolean;
  aspectRatio?: "16:9" | "4:3" | "1:1" | any;
  forceEagerLoading?: boolean;
  blackAndWhite?: boolean;
  sx?: BoxProps["sx"];
}

const Media: ReactFCWithNoJs<Props> = (props) => {
  const {
    imagePath,
    AltText,
    className,
    maxWidth,
    width,
    height,
    noWrapper,
    aspectRatio: aspectRatioInput,
    forceEagerLoading,
    blackAndWhite,
    sx,
  } = props;
  const styleOverride = props.styleOverride;
  const { useCloudinary, mediaUrl, env } = useContext(SettingsContext);

  const aspectRatio = width && height ? `${width}:${height}` : aspectRatioInput;

  const lazyLoadingEnabled = aspectRatio !== undefined;

  const logError = (publicId: string) => () => {
    logger.logError(`Error loading Cloudinary Image with publicId=${publicId}`);
  };

  const widthRatio = () => aspectRatio.split(":")[0];
  const heightRatio = () => aspectRatio.split(":")[1];

  if (styleOverride) {
    for (const prop in styleOverride) {
      if (!styleOverride[prop]) {
        delete styleOverride[prop];
      }
    }
  }
  const Img = useMemo(
    () => (props) => (
      <img
        {...props}
        width={aspectRatio ? widthRatio() : undefined}
        height={aspectRatio ? heightRatio() : undefined}
        fetchPriority={forceEagerLoading ? "high" : undefined}
        loading={forceEagerLoading ? "eager" : lazyLoadingEnabled ? "lazy" : "eager"}
      />
    ),
    [aspectRatio, forceEagerLoading, lazyLoadingEnabled],
  );
  const RenderImage = () => (
    <Box
      component={Img}
      key={imagePath}
      src={useCloudinary ? cloudinaryUrl(imagePath, env, maxWidth, aspectRatio) : `${mediaUrl}${imagePath}`}
      className={`${styles.imageFluid} ${className ?? ""} ${blackAndWhite ? (styles.blackAndWhite ?? "") : ""}`}
      alt={AltText}
      onError={logError(`cms${imagePath}`)}
      sizes="100vw" //Ads Sec-CH-Width and Sec-CH-ViewPort-Width in request header for cloudinary
      style={styleOverride}
      sx={sx}
    />
  );

  if (noWrapper) {
    return RenderImage();
  }

  return <div className={`bncms-component ${styles.media}`}>{RenderImage()}</div>;
};
Media.noJsRequired = true;
export default Media;
